import { isDefined } from '@aloft/toolkit-shared';

export function isWeb() {
  return isDefined(window);
}
